import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a work paused icon (a watch with a pause sign inside)
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WorkPausedIcon width={12} />
 */
const WorkPausedIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M24,12h0m3-8a2,2,0,1,0,0-4H21a2,2,0,1,0,0,4h6M37.58,8.42a1,1,0,1,0,1-1.73l-5.19-3a1,1,0,0,0-1,
        1.73l5.19,3M24,6A20,20,0,1,1,4,26,20,20,0,0,1,24,6m0,36A16,16,0,1,0,8,26,16,16,0,0,0,24,42m-2-8V18a2,2,0,0,0-4,
        0V34A2,2,0,0,0,22,34Zm8,0V18a2,2,0,0,0-4,0V34A2,2,0,0,0,30,34Z`}
        />
    </SvgIcon>
)

WorkPausedIcon.defaultProps = defaultProps

export { WorkPausedIcon }
